@use "@fukuri-admins/ui/layout" as *;

.contractPlanCol {
  width: 416px;
}

.colDate {
  @include colDate;
}
